var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5883 9.21831C25.8323 13.6918 24.3969 18.3328 20.4019 21.7776C16.4068 25.2464 9.85203 27.519 5.42637 24.7919C1.00071 22.0886 -1.29585 14.3377 0.761483 8.73986C2.81882 3.11807 9.23005 -0.374616 14.3495 0.0320667C19.4928 0.438749 23.3682 4.76872 24.5883 9.21831Z",
    fill: "#383D4A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_326_1053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4716 9.59729H16.1418V19.2323H14.4716V17.5742C13.6404 18.8465 12.4286 19.4836 10.8419 19.4836C9.49802 19.4836 8.35026 18.9907 7.40254 18.0087C6.45482 17.0267 5.98096 15.8284 5.98096 14.4158C5.98096 13.0031 6.45482 11.8049 7.40254 10.8209C8.35026 9.8389 9.49802 9.34595 10.8419 9.34595C12.4286 9.34595 13.6404 9.98308 14.4716 11.2554V9.59729ZM11.0536 17.8664C12.0266 17.8664 12.8403 17.5352 13.4928 16.8727C14.1453 16.2103 14.4716 15.3919 14.4716 14.4158C14.4716 13.4396 14.1453 12.6193 13.4928 11.9588C12.8403 11.2963 12.0246 10.9651 11.0536 10.9651C10.0826 10.9651 9.28633 11.2963 8.6338 11.9588C7.98127 12.6213 7.65306 13.4415 7.65306 14.4158C7.65306 15.39 7.97933 16.2122 8.6338 16.8727C9.28633 17.5352 10.0942 17.8664 11.0536 17.8664Z",
    fill: "#B8EF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9227 8.74798C17.6023 8.74798 17.3343 8.63887 17.1168 8.42065C16.8973 8.20242 16.7905 7.93939 16.7905 7.63153C16.7905 7.32368 16.8993 7.05675 17.1168 6.83073C17.3343 6.60666 17.6023 6.49365 17.9227 6.49365C18.2432 6.49365 18.4918 6.60666 18.7093 6.83073C18.9287 7.05675 19.0355 7.32173 19.0355 7.63153C19.0355 7.94133 18.9268 8.20242 18.7093 8.42065C18.4918 8.64082 18.2296 8.74798 17.9227 8.74798Z",
    fill: "#B8EF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.748 9.59741H17.0779V19.2324H18.748V9.59741Z",
    fill: "#B8EF36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_326_1053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0545,
    height: 12.9902,
    fill: "white",
    transform: "translate(5.98096 6.49414)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAiIcon);
export default __webpack_public_path__ + "static/media/sub_ai_icon.04445e3464e0c6ca2abb8146340ca2cc.svg";
export { ForwardRef as ReactComponent };